<template>
  <div class="heador" :class="{ fixed: true }">
    <div class="left">
      <span class="iconfont icon-fanhui"  @click="goBack()"></span>
    </div>
    <p class="title">{{ title }}</p>
    <div class="right" @click="goHistory"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    title: "",
    back: false,
    fixed: true,
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goHistory() {
      this.$router.push({
        path: '/refuelManageHistory'
      });
    },
  },
};
</script>

<style lang="less" scoped>
.fixed {
  position: fixed;
  z-index: 99;
}
.heador {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  background: transparent;
  height: .88rem /* 44/50 */;
  background: url(../../assets/images/refuelManage_head_bg.png) no-repeat 0px 0px;
  background-size: 7.5rem .88rem /* 44/50 */;
  .title {
    font-size: 0.32rem;
    font-weight: 550;
    color: #fff;
  }
  .left {
    width: .88rem /* 44/50 */;
    height: .88rem /* 44/50 */;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: 0;
    top: 0;
    span {
      font-size: 0.4rem;
      color: #fff;
    }
  }
  .right {
    min-width: .88rem /* 44/50 */;
    min-height: .88rem /* 44/50 */;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    right: 0.3rem;
    top: 0;
    color: #fff;
  }
}
</style>